import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//样式normalize
import 'style/border.css'
import 'style/reset.css'
//公共样式
import 'style/index.css'
//silkRoadBase样式（移植而来）
import './common/style/silkRoadBase/information.css'
import './common/style/silkRoadBase/intelligence.css'
import './common/style/silkRoadBase/isIE.css'
import './common/style/silkRoadBase/nanoscroller.css'
import './common/style/silkRoadBase/video-js.min.css'
import './common/style/silkRoadBase/video_signal.css'
import VueTianditu from 'vue-tianditu'
import VueScroll from 'vuescroll'


import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import xhs from '@/utils/appXhs'

import axios from 'axios'
import locale from 'element-ui/lib/locale/lang/en'
import jquery from 'jquery'
import * as _ from 'lodash'
import * as d3 from 'd3'
// 引入加载js
import loadScript from '@/common/js/utils/importJs'
import {pdAxios} from '@/common/js/http/pdAxios'

window.jQuery = window.jquery = window.$ = jquery
window.d3 = d3
window.loadsh = _
loadScript('https://res.imsilkroad.com/t/site/10001/462981b58356fd9a09cc727cb57e1f4e/assets/js/pd-dc-graph-concept.js')

Vue.prototype.$axios = axios

import '@/views/silkRoadBase/components/swiper/swiper.min.css'
// 引入load 加载select2和Scroller
import Load from './load'
import isPC from './isPC'


Vue.use(Load)
Vue.use(isPC)
Vue.use(VueTianditu, {
  v: '4.0',
  tk: 'ed564f9c0ee383bb453cd76d135c8fee'
})
Vue.use(VueScroll,{
  name: 'vue-scroll'
})

import 'view-design/dist/styles/iview.css'
import '@/views/pbr/components/iView'
import apis from '@/views/pbr/apis/index'
Vue.use(apis)
import i18n from './views/pbr/components/I18n'

router.beforeEach((to, from, next) => {
  // console.log("TCL: to", to)
  // console.log("TCL: from", from)
  next()
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(ElementUI, {locale})

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.xhs = xhs // ajax请求方法
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$pdAxios = pdAxios
import lodash from 'lodash'

Vue.prototype.$lodash = lodash

import Cookies from 'js-cookie'

Vue.prototype.Cookies = Cookies

import moment from 'moment'

Vue.prototype.$moment = moment

Vue.config.productionTip = false

// Echarts 使用
import ECharts from 'vue-echarts/components/ECharts.vue'

Vue.component('v-chart', ECharts)

Vue.prototype.$Echarts = ECharts

import VueWorker from 'vue-worker'

Vue.use(VueWorker)

import 'echarts'

// 手动引入 ECharts 各模块来减小打包体积
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/map/js/china.js'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title.js'
import echartWordcloud from 'vue-echart-wordcloud'

Vue.use(echartWordcloud)

Vue.prototype.$IframeTestUrl = 'http://10.100.1.54:9000'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

import '@/views/pbr/common/css/common.css'
//brand二期引入
import '@/views/brand/assets/css/common.css'


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
